import type { FavoritePageState } from '../domain/types'

export function favoritePageSelector(state: FavoritePageState) {
  return {
    allFavouritesRemovalStatus: state.allFavouritesRemovalStatus,
    loadStatus: state.loadStatus,
    results: state.results,
    removingProductIds: state.removingProductIds,
  }
}
